// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__4D3JV","label":"SetPasswdForm_label__1yXOQ"};